<template>
  <main class="bg-auth-background bg-auth-grain relative z-0 flex-1 overflow-y-auto focus:outline-hidden" tabindex="0">
    <div class="flex min-h-screen flex-col justify-center">
      <router-view />
    </div>
  </main>
</template>
